import { useEffect, useState } from 'react';

export const useSidebarCollapsed = (): boolean => {
  const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);
  const asideTag = document.getElementsByTagName('aside')[0];

  useEffect(() => {
    if (asideTag) {
      const resizeObserver = new ResizeObserver((entries: any) => {
        setSidebarCollapsed(entries[0].contentRect.width < 250);
      });

      resizeObserver.observe(asideTag);

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, [asideTag]);

  return isSidebarCollapsed;
};
